// highligt.js
export const LANGS: { [id: string]: string } = {
    "1c": "1C:Enterprise",
    "abnf": "Augmented Backus-Naur Form",
    "accesslog": "Apache Access Log",
    "actionscript": "ActionScript",
    "as": "ActionScript",
    "ada": "Ada",
    "angelscript": "AngelScript",
    "asc": "AngelScript",
    "apache": "Apache config",
    "apacheconf": "Apache config",
    "applescript": "AppleScript",
    "osascript": "AppleScript",
    "arcade": "ArcGIS Arcade",
    "arduino": "Arduino",
    "ino": "Arduino",
    "armasm": "ARM Assembly",
    "arm": "ARM Assembly",
    "asciidoc": "AsciiDoc",
    "adoc": "AsciiDoc",
    "aspectj": "AspectJ",
    "autohotkey": "AutoHotkey",
    "ahk": "AutoHotkey",
    "autoit": "AutoIt",
    "avrasm": "AVR Assembly",
    "awk": "Awk",
    "axapta": "X++",
    "x++": "X++",
    "bash": "Bash",
    "sh": "Bash",
    "zsh": "Bash",
    "basic": "BASIC",
    "bnf": "Backus–Naur Form",
    "brainfuck": "Brainfuck",
    "bf": "Brainfuck",
    "c": "C",
    "h": "C",
    "cal": "C/AL",
    "capnproto": "Cap’n Proto",
    "capnp": "Cap’n Proto",
    "ceylon": "Ceylon",
    "clean": "Clean",
    "icl": "Clean",
    "dcl": "Clean",
    "clojure": "Clojure",
    "clj": "Clojure",
    "edn": "Clojure",
    "clojure-repl": "Clojure REPL",
    "cmake": "CMake",
    "cmake.in": "CMake",
    "coffeescript": "CoffeeScript",
    "coffee": "CoffeeScript",
    "cson": "CoffeeScript",
    "iced": "CoffeeScript",
    "coq": "Coq",
    "cos": "Caché Object Script",
    "cls": "Caché Object Script",
    "cpp": "C++",
    "cc": "C++",
    "c++": "C++",
    "h++": "C++",
    "hpp": "C++",
    "hh": "C++",
    "hxx": "C++",
    "cxx": "C++",
    "crmsh": "crmsh",
    "crm": "crmsh",
    "pcmk": "crmsh",
    "crystal": "Crystal",
    "cr": "Crystal",
    "csharp": "C#",
    "cs": "C#",
    "c#": "C#",
    "csp": "CSP",
    "css": "CSS",
    "d": "D",
    "dart": "Dart",
    "delphi": "Delphi",
    "dpr": "Delphi",
    "dfm": "Delphi",
    "pas": "Delphi",
    "pascal": "Delphi",
    "diff": "Diff",
    "patch": "Diff",
    "django": "Django",
    "jinja": "Django",
    "dns": "DNS Zone",
    "bind": "DNS Zone",
    "zone": "DNS Zone",
    "dockerfile": "Dockerfile",
    "docker": "Dockerfile",
    "dos": "Batch file (DOS)",
    "bat": "Batch file (DOS)",
    "cmd": "Batch file (DOS)",
    "dsconfig": "dsconfig",
    "dts": "Device Tree",
    "dust": "Dust",
    "dst": "Dust",
    "ebnf": "Extended Backus-Naur Form",
    "elixir": "Elixir",
    "ex": "Elixir",
    "exs": "Elixir",
    "elm": "Elm",
    "erb": "ERB",
    "erlang": "Erlang",
    "erl": "Erlang",
    "erlang-repl": "Erlang REPL",
    "excel": "Excel formulae",
    "xlsx": "Excel formulae",
    "xls": "Excel formulae",
    "fix": "FIX",
    "flix": "Flix",
    "fortran": "Fortran",
    "f90": "Fortran",
    "f95": "Fortran",
    "fsharp": "F#",
    "fs": "F#",
    "f#": "F#",
    "gams": "GAMS",
    "gms": "GAMS",
    "gauss": "GAUSS",
    "gss": "GAUSS",
    "gcode": "G-code (ISO 6983)",
    "nc": "G-code (ISO 6983)",
    "gherkin": "Gherkin",
    "feature": "Gherkin",
    "glsl": "GLSL",
    "gml": "GML",
    "go": "Go",
    "golang": "Go",
    "golo": "Golo",
    "gradle": "Gradle",
    "graphql": "GraphQL",
    "gql": "GraphQL",
    "groovy": "Groovy",
    "haml": "HAML",
    "handlebars": "Handlebars",
    "hbs": "Handlebars",
    "html.hbs": "Handlebars",
    "html.handlebars": "Handlebars",
    "htmlbars": "Handlebars",
    "haskell": "Haskell",
    "hs": "Haskell",
    "haxe": "Haxe",
    "hx": "Haxe",
    "hsp": "HSP",
    "http": "HTTP",
    "https": "HTTP",
    "hy": "Hy",
    "hylang": "Hy",
    "inform7": "Inform 7",
    "i7": "Inform 7",
    "ini": "TOML, also INI",
    "toml": "TOML, also INI",
    "irpf90": "IRPF90",
    "isbl": "ISBL",
    "java": "Java",
    "jsp": "Java",
    "javascript": "JavaScript",
    "js": "JavaScript",
    "jsx": "JavaScript",
    "mjs": "JavaScript",
    "cjs": "JavaScript",
    "jboss-cli": "JBoss CLI",
    "wildfly-cli": "JBoss CLI",
    "json": "JSON",
    "jsonc": "JSONC",
    "julia": "Julia",
    "julia-repl": "Julia REPL",
    "jldoctest": "Julia REPL",
    "kotlin": "Kotlin",
    "kt": "Kotlin",
    "kts": "Kotlin",
    "lasso": "Lasso",
    "ls": "LiveScript",
    "lassoscript": "Lasso",
    "latex": "LaTeX",
    "tex": "LaTeX",
    "ldif": "LDIF",
    "leaf": "Leaf",
    "less": "Less",
    "lisp": "Lisp",
    "livecodeserver": "LiveCode",
    "livescript": "LiveScript",
    "llvm": "LLVM IR",
    "lsl": "LSL (Linden Scripting Language)",
    "lua": "Lua",
    "makefile": "Makefile",
    "mk": "Makefile",
    "mak": "Makefile",
    "make": "Makefile",
    "markdown": "Markdown",
    "md": "Markdown",
    "mkdown": "Markdown",
    "mkd": "Markdown",
    "mathematica": "Mathematica",
    "mma": "Mathematica",
    "wl": "Mathematica",
    "matlab": "Matlab",
    "maxima": "Maxima",
    "mel": "MEL",
    "mercury": "Mercury",
    "m": "Mercury",
    "moo": "Mercury",
    "mipsasm": "MIPS Assembly",
    "mips": "MIPS Assembly",
    "mizar": "Mizar",
    "mojolicious": "Mojolicious",
    "monkey": "Monkey",
    "moonscript": "MoonScript",
    "moon": "MoonScript",
    "n1ql": "N1QL",
    "nestedtext": "Nested Text",
    "nt": "Nested Text",
    "nginx": "Nginx config",
    "nginxconf": "Nginx config",
    "nim": "Nim",
    "nix": "Nix",
    "nixos": "Nix",
    "node-repl": "Node REPL",
    "nsis": "NSIS",
    "objectivec": "Objective-C",
    "mm": "Objective-C",
    "objc": "Objective-C",
    "obj-c": "Objective-C",
    "obj-c++": "Objective-C",
    "objective-c++": "Objective-C",
    "ocaml": "OCaml",
    "ml": "SML (Standard ML)",
    "openscad": "OpenSCAD",
    "scad": "OpenSCAD",
    "oxygene": "Oxygene",
    "parser3": "Parser3",
    "perl": "Perl",
    "pl": "Perl",
    "pm": "Perl",
    "pf": "Packet Filter config",
    "pf.conf": "Packet Filter config",
    "pgsql": "PostgreSQL",
    "postgres": "PostgreSQL",
    "postgresql": "PostgreSQL",
    "php": "php",
    "php-template": "PHP template",
    "plaintext": "Plain text",
    "text": "Plain text",
    "txt": "Plain text",
    "pony": "Pony",
    "powershell": "PowerShell",
    "pwsh": "PowerShell",
    "ps": "PowerShell",
    "ps1": "PowerShell",
    "processing": "Processing",
    "pde": "Processing",
    "profile": "Python profiler",
    "prolog": "Prolog",
    "properties": ".properties",
    "protobuf": "Protocol Buffers",
    "proto": "Protocol Buffers",
    "puppet": "Puppet",
    "pp": "Puppet",
    "purebasic": "PureBASIC",
    "pb": "PureBASIC",
    "pbi": "PureBASIC",
    "python": "Python",
    "py": "Python",
    "gyp": "Python",
    "ipython": "Python",
    "python-repl": "python-repl",
    "pycon": "python-repl",
    "q": "Q",
    "k": "Q",
    "kdb": "Q",
    "qml": "QML",
    "qt": "QML",
    "r": "R",
    "reasonml": "ReasonML",
    "re": "ReasonML",
    "rib": "RenderMan RIB",
    "roboconf": "Roboconf",
    "graph": "Roboconf",
    "instances": "Roboconf",
    "routeros": "MikroTik RouterOS script",
    "mikrotik": "MikroTik RouterOS script",
    "rsl": "RenderMan RSL",
    "ruby": "Ruby",
    "rb": "Ruby",
    "gemspec": "Ruby",
    "podspec": "Ruby",
    "thor": "Ruby",
    "irb": "Ruby",
    "ruleslanguage": "Oracle Rules Language",
    "rust": "Rust",
    "rs": "Rust",
    "sas": "SAS",
    "scala": "Scala",
    "scheme": "Scheme",
    "scm": "Scheme",
    "scilab": "Scilab",
    "sci": "Scilab",
    "scss": "SCSS",
    "shell": "Shell Session",
    "console": "Shell Session",
    "shellsession": "Shell Session",
    "smali": "Smali",
    "smalltalk": "Smalltalk",
    "st": "Smalltalk",
    "sml": "SML (Standard ML)",
    "sqf": "SQF",
    "sql": "SQL",
    "stan": "Stan",
    "stanfuncs": "Stan",
    "stata": "Stata",
    "do": "Stata",
    "ado": "Stata",
    "step21": "STEP Part 21",
    "p21": "STEP Part 21",
    "step": "STEP Part 21",
    "stp": "STEP Part 21",
    "stylus": "Stylus",
    "styl": "Stylus",
    "subunit": "SubUnit",
    "swift": "Swift",
    "taggerscript": "Tagger Script",
    "tap": "Test Anything Protocol",
    "tcl": "Tcl",
    "tk": "Tcl",
    "thrift": "Thrift",
    "tp": "TP",
    "twig": "Twig",
    "craftcms": "Twig",
    "typescript": "TypeScript",
    "ts": "TypeScript",
    "tsx": "TypeScript",
    "mts": "TypeScript",
    "cts": "TypeScript",
    "vala": "Vala",
    "vbnet": "Visual Basic .NET",
    "vb": "Visual Basic .NET",
    "vbscript": "VBScript",
    "vbs": "VBScript",
    "vbscript-html": "VBScript in HTML",
    "verilog": "Verilog",
    "v": "Verilog",
    "sv": "Verilog",
    "svh": "Verilog",
    "vhdl": "VHDL",
    "vim": "Vim Script",
    "wasm": "WebAssembly",
    "wren": "Wren",
    "x86asm": "Intel x86 Assembly",
    "xl": "XL",
    "tao": "XL",
    "xml": "HTML, XML",
    "html": "HTML, XML",
    "xhtml": "HTML, XML",
    "rss": "HTML, XML",
    "atom": "HTML, XML",
    "xjb": "HTML, XML",
    "xsd": "HTML, XML",
    "xsl": "HTML, XML",
    "plist": "HTML, XML",
    "wsf": "HTML, XML",
    "svg": "HTML, XML",
    "xquery": "XQuery",
    "xpath": "XQuery",
    "xq": "XQuery",
    "xqm": "XQuery",
    "yaml": "YAML",
    "yml": "YAML",
    "zephir": "Zephir",
    "zep": "Zephir",
    "log": "Text logs"
};

export const LANG_NAMES: { [id: string]: string } = {
    "1C:Enterprise": "1c",
    "Augmented Backus-Naur Form": "abnf",
    "Apache Access Log": "accesslog",
    "ActionScript": "actionscript",
    "Ada": "ada",
    "AngelScript": "angelscript",
    "Apache config": "apache",
    "AppleScript": "applescript",
    "ArcGIS Arcade": "arcade",
    "Arduino": "arduino",
    "ARM Assembly": "armasm",
    "AsciiDoc": "asciidoc",
    "AspectJ": "aspectj",
    "AutoHotkey": "autohotkey",
    "AutoIt": "autoit",
    "AVR Assembly": "avrasm",
    "Awk": "awk",
    "X++": "axapta",
    "Bash": "bash",
    "BASIC": "basic",
    "Backus–Naur Form": "bnf",
    "Brainfuck": "brainfuck",
    "C": "c",
    "C/AL": "cal",
    "Cap’n Proto": "capnproto",
    "Ceylon": "ceylon",
    "Clean": "clean",
    "Clojure": "clojure",
    "Clojure REPL": "clojure-repl",
    "CMake": "cmake",
    "CoffeeScript": "coffeescript",
    "Coq": "coq",
    "Caché Object Script": "cos",
    "C++": "cpp",
    "crmsh": "crmsh",
    "Crystal": "crystal",
    "C#": "csharp",
    "CSP": "csp",
    "CSS": "css",
    "D": "d",
    "Dart": "dart",
    "Delphi": "delphi",
    "Diff": "diff",
    "Django": "django",
    "DNS Zone": "dns",
    "Dockerfile": "dockerfile",
    "Batch file (DOS)": "dos",
    "dsconfig": "dsconfig",
    "Device Tree": "dts",
    "Dust": "dust",
    "Extended Backus-Naur Form": "ebnf",
    "Elixir": "elixir",
    "Elm": "elm",
    "ERB": "erb",
    "Erlang": "erlang",
    "Erlang REPL": "erlang-repl",
    "Excel formulae": "excel",
    "FIX": "fix",
    "Flix": "flix",
    "Fortran": "fortran",
    "F#": "fsharp",
    "GAMS": "gams",
    "GAUSS": "gauss",
    "G-code (ISO 6983)": "gcode",
    "Gherkin": "gherkin",
    "GLSL": "glsl",
    "GML": "gml",
    "Go": "go",
    "Golo": "golo",
    "Gradle": "gradle",
    "GraphQL": "graphql",
    "Groovy": "groovy",
    "HAML": "haml",
    "Handlebars": "handlebars",
    "Haskell": "haskell",
    "Haxe": "haxe",
    "HSP": "hsp",
    "HTTP": "http",
    "Hy": "hy",
    "Inform 7": "inform7",
    "TOML, also INI": "ini",
    "IRPF90": "irpf90",
    "ISBL": "isbl",
    "Java": "java",
    "JavaScript": "javascript",
    "JBoss CLI": "jboss-cli",
    "JSON": "json",
    "Julia": "julia",
    "Julia REPL": "julia-repl",
    "Kotlin": "kotlin",
    "Lasso": "lasso",
    "LaTeX": "latex",
    "LDIF": "ldif",
    "Leaf": "leaf",
    "Less": "less",
    "Lisp": "lisp",
    "LiveCode": "livecodeserver",
    "LiveScript": "livescript",
    "LLVM IR": "llvm",
    "LSL (Linden Scripting Language)": "lsl",
    "Lua": "lua",
    "Makefile": "makefile",
    "Markdown": "markdown",
    "Mathematica": "mathematica",
    "Matlab": "matlab",
    "Maxima": "maxima",
    "MEL": "mel",
    "Mercury": "mercury",
    "MIPS Assembly": "mipsasm",
    "Mizar": "mizar",
    "Mojolicious": "mojolicious",
    "Monkey": "monkey",
    "MoonScript": "moonscript",
    "N1QL": "n1ql",
    "Nested Text": "nestedtext",
    "Nginx config": "nginx",
    "Nim": "nim",
    "Nix": "nix",
    "Node REPL": "node-repl",
    "NSIS": "nsis",
    "Objective-C": "objectivec",
    "OCaml": "ocaml",
    "OpenSCAD": "openscad",
    "Oxygene": "oxygene",
    "Parser3": "parser3",
    "Perl": "perl",
    "Packet Filter config": "pf",
    "PostgreSQL": "pgsql",
    "php": "php",
    "PHP template": "php-template",
    "Plain text": "plaintext",
    "Pony": "pony",
    "PowerShell": "powershell",
    "Processing": "processing",
    "Python profiler": "profile",
    "Prolog": "prolog",
    ".properties": "properties",
    "Protocol Buffers": "protobuf",
    "Puppet": "puppet",
    "PureBASIC": "purebasic",
    "Python": "python",
    "python-repl": "python-repl",
    "Q": "q",
    "QML": "qml",
    "R": "r",
    "ReasonML": "reasonml",
    "RenderMan RIB": "rib",
    "Roboconf": "roboconf",
    "MikroTik RouterOS script": "routeros",
    "RenderMan RSL": "rsl",
    "Ruby": "ruby",
    "Oracle Rules Language": "ruleslanguage",
    "Rust": "rust",
    "SAS": "sas",
    "Scala": "scala",
    "Scheme": "scheme",
    "Scilab": "scilab",
    "SCSS": "scss",
    "Shell Session": "shell",
    "Smali": "smali",
    "Smalltalk": "smalltalk",
    "SML (Standard ML)": "sml",
    "SQF": "sqf",
    "SQL": "sql",
    "Stan": "stan",
    "Stata": "stata",
    "STEP Part 21": "step21",
    "Stylus": "stylus",
    "SubUnit": "subunit",
    "Swift": "swift",
    "Tagger Script": "taggerscript",
    "Test Anything Protocol": "tap",
    "Tcl": "tcl",
    "Thrift": "thrift",
    "TP": "tp",
    "Twig": "twig",
    "TypeScript": "typescript",
    "Vala": "vala",
    "Visual Basic .NET": "vbnet",
    "VBScript": "vbscript",
    "VBScript in HTML": "vbscript-html",
    "Verilog": "verilog",
    "VHDL": "vhdl",
    "Vim Script": "vim",
    "WebAssembly": "wasm",
    "Wren": "wren",
    "Intel x86 Assembly": "x86asm",
    "XL": "xl",
    "HTML, XML": "xml",
    "XQuery": "xquery",
    "YAML": "yaml",
    "Zephir": "zephir",
    "Text logs": "log"
};

export const MIME2LANG: { [id: string]: string } = {
    'text/css': 'css',
    'text/html': 'xml',
    'text/json': 'json',
    'application/json': 'json',
    'text/javascript': 'javascript',
    'application/ecmascript': 'javascript',
    'application/javascript': 'javascript',
    'application/x-ecmascript': 'javascript',
    'application/x-javascript': 'javascript',
    'text/ecmascript': 'javascript',
    'text/javascript1.0': 'javascript',
    'text/javascript1.1': 'javascript',
    'text/javascript1.2': 'javascript',
    'text/javascript1.3': 'javascript',
    'text/javascript1.4': 'javascript',
    'text/javascript1.5': 'javascript',
    'text/jscript': 'javascript',
    'text/livescript': 'javascript',
    'text/x-ecmascript': 'javascript',
    'text/x-javascript': 'javascript',
    'text/markdown': 'markdown',
    'text/x-markdown': 'markdown',
    'text/plain': 'plaintext',
    'text/sgml': 'xml',
    'text/tab-separated-values': 'plaintext',
    'text/x-asm': 'x86asm',
    'text/x-c': 'cpp',
    'text/x-csharp': 'csharp',
    'text/x-diff': 'diff',
    'text/x-fortran': 'fortran',
    'text/x-java-source': 'java',
    'text/x-pascal': 'delphi',
    'text/x-python': 'python',
    'text/xml': 'xml',
    'application/xml': 'xml',
    'text/xml-external-parsed-entity': 'xml',
    'application/xml-external-parsed-entity': 'xml',
    'application/xml-dtd': 'xml',
    'application/pgp': '',
    'application/pgp-keys': '',
    'application/pgp-encrypted': '',
    'application/pgp-signature': '',
    'application/x-perl': 'perl',
    'application/x-sh': 'bash',
    'application/x-shellscript': 'bash',
    'application/x-tcl': 'tcl',
    'application/pkcs8': '',
    'application/pkcs10': '',
    'application/pkix-cert': '',
    'application/pkix-crl': '',
    'application/pkcs7-mime': '',
    'application/x-x509-ca-cert': '',
    'application/x-x509-user-cert': '',
    'application/x-pkcs7-crl': '',
    'application/x-pem-file': '',
    'application/x-pkcs12': '',
    'application/x-pkcs7-certificates': '',
    'application/x-pkcs7-certreqresp': '',
    'application/vnd.commonspace': 'csp',
    'image/svg+xml': 'xml',
};
